import * as types from "./actions";
import { isNullOrEmpty } from "../../../../utils/common";

const defaultState = {
    list: [],
    filterDate: null
}

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case types.LIST:
            let orderList = [...action.payload];
            orderList.map((order)=> order.hasOrder = !isNullOrEmpty(order.orderedProducts));
            orderList.map((order)=> order.isPlainBG = (!isNullOrEmpty(order.orderedProducts) ? order.updPgmId.localeCompare('true'): false));
            return { ...state, list: orderList };
        case types.FILTER_DATE:
            return { ...state, filterDate: action.payload };
        default: // need this for default case
            return state
    }
};
